import React from "react";
import style from "../../../scss/Conteo.module.scss";

// Fila del acta E-14: etiqueta a la izquierda y casilla de votos a la derecha.
// "children" reemplaza la etiqueta cuando se necesita más contenido (candidato).
const CampoVotosComponent = ({ id, etiqueta, valor, onChange, children }) => (
  <div className={style.fila}>
    <label htmlFor={id} className={style.filaEtiqueta}>
      {children ?? etiqueta}
    </label>
    <input
      id={id}
      type="number"
      min="0"
      step="1"
      inputMode="numeric"
      className={`form-control form-control-lg ${style.filaValor}`}
      value={valor}
      onChange={(e) => onChange(e.target.value)}
      required
    />
  </div>
);

export default CampoVotosComponent;
